import interactionDefaultStyle from "@assets/config/interaction.style.default";
import _ from "lodash";

export default {
    state: {
        list: [],

        interactionElements: [],

        tab: null,

        colorPicker: {
            interactionId: undefined,
            active: false,
            type: undefined,
            color: {
                r: undefined,
                g: undefined,
                b: undefined,
                a: undefined,
            },
        },
    },

    mutations: {
        SET_INTERACTIONS: (state, payload) => {
            const interactions = [];

            _.forEach(payload, (interaction) => {
                _.forEach(interaction.opcoes, (option, index) => {
                    if (typeof option.estilo === "string")
                        option.estilo = JSON.parse(option.estilo);
                    else {
                        interaction.opcoes[index].estilo = option.estilo;
                    }
                });

                if (typeof interaction.estilo === "string") {
                    interaction.estilo = JSON.parse(interaction.estilo);
                }

                if (!interaction.estilo) {
                    interaction.estilo = interactionDefaultStyle;
                }

                interactions.push(interaction);
            });

            state.list = interactions;
        },

        SET_INTERACTION_DATA: (state, { interactionId, data }) => {
            const item = _.find(state.list, (interaction) => {
                return interaction.id === interactionId;
            });

            _.forEach(data, (value, key) => {
                item[key] = value;
            });
        },

        SET_INTERACTION_OPTIONS: (state, { interactionId, data }) => {
            const item = _.find(state.list, (interaction) => {
                return interaction.id === interactionId;
            });
            const options = [];

            _.forEach(data, (option) => {
                if (typeof option.estilo === "string")
                    option.estilo = JSON.parse(option.estilo);

                options.push(option);
            });

            item.opcoes = options;
        },

        BIND_INTERACTION_ELEMENT: (state, { interaction, element }) => {
            state.interactionElements.push({
                interaction,
                element,
            });
        },

        UNBIND_INTERACTION_ELEMENT: (state, { interaction }) => {
            const index = _.findIndex(state.interactionElements, (int) => {
                return int.interaction.id === interaction.id;
            });

            state.interactionElements.splice(index, 1);

        },

        INTERACTIONS_SET_TAB(state, tab) {
            state.tab = tab;
        },

        SET_COLOR_PICKER_STATE_INTERACTION(state, { active, interactionId, type }) {
            state.colorPicker.active = active;
            state.colorPicker.interactionId = interactionId;
            state.colorPicker.type = type;
        },

        SET_COLOR_PICKER_VAL_INTERACTION(state, val) {
            state.colorPicker.color = val;
        },
    },
};
